<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>Search for your product</h1>
    </div>

    <div class="container">
      <br>
      <div v-if="currentItems.length === 0">No items found</div>
      <p class="text-center text-uppercase">Please click on your item to continue.</p>
      <table id="product-results" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th
              v-for="(field, index) in tableFields" :key="index"
              class="text-center"
              >{{field.displayName}}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item) in currentItems" :key="item.id"
            class="clickable text-center grey-outline"
            @click.prevent="goItemDetails(item)"
            >
            <td
              v-for="(field, index) in tableFields" :key="index">
              {{ item[field.field] }}
              </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <paginate
          class = "client-pagination"
          v-model="currentPage"
          :page-count="pageCount"
          :click-handler="switchPage"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'">
        </paginate>
        <br>
        <br>
        <div class="col-sm-3 row">
          <a
            href=""
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
            @click.prevent="goItemSearch"
          >
            <span class="glyphicon-chevron-left glyphicon"></span> Back
          </a>
        </div>
      </div>
      <br><br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Paginate from 'vuejs-paginate'

export default {
  name: 'ItemSearchResults',
  data () {
    return {
      currentPage: 1,
      sortByDate: (a, b) => {
        return (new Date(a.created_at) - new Date(b.created_at)) * -1 // ascending order
      }
    }
  },
  components: {
    'paginate': Paginate
  },
  props: {
    filters: {}
  },
  computed: {
    ...mapState('loyaltyProgram', {
      rebateItems: state => state.program.rebateItems.filter(item => !item.disabled),
      rebateItemFields: state => state.program.rebateItemFields
    }),
    tableFields () {
      return this.rebateItemFields.sort((firstEl, secondEl) => firstEl.field < secondEl.field)
    },
    filteredItems () {
      return this.rebateItems.filter(item => {
        const invalid = Object.keys(this.filters || {})
          .filter(key => this.filters[key] !== null)
          .find(key => {
            return this.notEq(item[key], this.filters[key])
          })
        return invalid === undefined
      })
    },
    sortedItems () {
      return this.filteredItems.sort(this.sortByDate)
    },
    pageCount () {
      return Math.ceil(this.sortedItems.length / 10)
    },
    startIdx () {
      return (this.currentPage - 1) * 10
    },
    endIdx () {
      return this.currentPage * 10
    },
    currentItems () {
      return this.currentPage === this.pageCount
        ? this.sortedItems.slice(this.startIdx)
        : this.sortedItems.slice(this.startIdx, this.endIdx)
    }
  },
  methods: {
    switchPage (page) {
      console.log(page)
    },
    goItemSearch () {
      this.$bus.emit('swapComponent', { component: 'item-search' })
    },
    goItemDetails (item) {
      this.$bus.emit('swapComponent', { component: 'item-details', props: { item, filters: this.filters } })
    },
    notEq (val, filter) {
      switch (typeof filter) {
        case 'string':
          return !val.toLowerCase().includes(filter.toLowerCase())
        default:
          return val !== filter
      }
    }
  }
}
</script>

<style scoped>
#product-results {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  border-spacing: 10px;
}

#product-results td, #product-results th {
  padding: 15px 5px;
}

#product-results tr:hover td {
  background-color: transparent; /* or #000 */
}
</style>
